"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Container = _interopRequireDefault(require("../Container"));

var _Grid = _interopRequireDefault(require("../Grid"));

var __jsx = _react["default"].createElement;

function GridDebugger(props) {
  var _useState = (0, _react.useState)(null),
      cols = _useState[0],
      setCols = _useState[1];

  var onKeyPress = function onKeyPress(event) {
    if (event.keyCode === 71 && event.ctrlKey) {
      if (cols) {
        setCols(null);
      } else {
        var _cols = (0, _parseInt2["default"])(window.prompt("How many columns?", "12"));

        setCols(_cols);
      }
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", onKeyPress, false);
    return function () {
      document.removeEventListener("keydown", onKeyPress, false);
    };
  });

  if (!cols) {
    return null;
  }

  return __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      left: 0,
      top: 0,
      width: "100%",
      zIndex: "10000",
      overflow: "hidden",
      pointerEvents: "none"
    }
  }, __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: cols
  }, (0, _toConsumableArray2["default"])(Array(cols)).map(function (e, i) {
    return __jsx(_Box["default"], {
      sx: {
        position: "relative",
        height: "100vh",
        bg: "coral",
        opacity: 0.3
      },
      key: i
    });
  }))));
}

var _default = GridDebugger;
exports["default"] = _default;